import { Buffer } from "buffer";
import numberFormatter from "number-formatter";
const CryptoJS = require("crypto-js");
// const crypto = require("crypto");

export const encryptObj = data =>
  CryptoJS.AES.encrypt(
    JSON.stringify(data),
    process.env.REACT_APP_ENCRYPTION_SECRET_KEY
  ).toString();

export const decryptObj = cipherText => {
  const bytes = CryptoJS.AES.decrypt(
    cipherText,
    process.env.REACT_APP_ENCRYPTION_SECRET_KEY
  );
  return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
};

export const encryptUsingPublicKey = (obj, key) => {
  const buffer = Buffer.from(JSON.stringify(obj), "utf8");
  const encrypted = crypto.publicEncrypt(key, buffer);
  return encrypted.toString("base64");
};

export const encodeString = value => window.btoa(value);
export const decodeString = value => window.atob(value);

export const isOrg =
  process.env.REACT_APP_ENV === "org" || process.env.NODE_ENV === "production";

export const discountAmount = (actualPrice, discount = 20) => {
  return ((+actualPrice * +discount) / 100).toFixed(2);
};

export const afterDiscountAmount = (actualPrice, discount = 20) => {
  return +actualPrice - (+actualPrice * +discount) / 100;
};

export const getDuration = duration => {
  switch (Math.floor(duration / 30)) {
    case 1:
    case 2:
      return "Monthly Payment";
    case 3:
    case 4:
    case 5:
      // return "4 Payments / year";
      return "Pay in 4 (installments)";
    case 6:
    case 7:
    case 8:
      return "Half Yearly Payment";
    case 9:
    case 10:
    case 11:
    case 12:
      return "Annual Payment";
    default:
      return "";
  }
};

export const getDurationInPerFormat = duration => {
  switch (Math.floor(duration / 30)) {
    case 1:
    case 2:
      return "/ Month";
    case 3:
    case 4:
    case 5:
      return "/ Quarterly";
    case 6:
    case 7:
    case 8:
      return "/ 6-Months";
    case 9:
    case 10:
    case 11:
    case 12:
      return "/ Year";
    default:
      return "";
  }
};

export const removeVolume = product => {
  return product.replace(/V\d+/, "");
};

export const formatNumber = num => {
  return numberFormatter("$#,##0.00", num);
};
